import React, { useEffect, useState } from "react";

import "../../styles/auth.css";
import "../../styles/index.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useAuth } from "../../services/authentication/authentication.context";
import { Loader } from "../../components/utilities/loader";
import { GLoginscreen } from "./google.auth";
import { AppAlert } from "../../components/utilities/alert";
import { isNull } from "../../helpers/utility-methods";

export const LoginForm = () => {

    const [credentials, setCredentials] = useState({
        email: "",
        password: ""
    });

    const [toggleShow, setToggleShow] = useState(false);
    const [errAlert, setAlert] = useState();

    const { loginUser, isLoading, isAuthenticated, googleLogin } = useAuth();

    const { email, password } = credentials;

    useEffect(() => {
        if (isAuthenticated === true) {
            window.location.href = "/";
        }
    }, [isAuthenticated]);

    const handleLogin = async () => {
        if (isNull(email) || isNull(password)) {
            setAlert({
                caption: 'Invalid credentials!',
                message: 'Please provide an email and password!',
                acceptAction: () => setAlert(),
                accept: "Ok"
            })
        }
        let res = await loginUser(email, password);

        if (res?.authError) {
            return setAlert({
                caption: 'Invalid Login',
                message: res?.authError,
                accept: 'Ok',
                accepAction: () => setAlert()
            });
        }
    }

    return (
        <div className="centered-page">
            {isLoading && <Loader />}
            {errAlert && (
                <AppAlert
                    caption={errAlert.caption}
                    message={errAlert.message}
                    reject={errAlert.reject}
                    accept={errAlert.accept}
                    rejectAction={errAlert.rejectAction}
                    acceptAction={errAlert.accepAction}
                    close={() => setAlert()}
                />)}
            <div className="page-caption">
                <span className="wlc-cap">Welcome back!</span>
                <span className="wlc-cap">Sign in</span>
            </div>
            <div className="alert-mid">
                <button
                    className='alert-caption tr-btn'
                    onClick={() => window.location.href = "/"}
                    style={{ cursor: "pointer" }}
                >
                    <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 24 }} />
                    <div className='wlc-cap'>Back to Home page</div>
                </button>
            </div>
            <form
                className="form-container"
                onSubmit={ async(e) => {
                    e.preventDefault();
                    await handleLogin();
                }}
            >
                <div className="input-container">
                    <span className="input-cap">Email</span>
                    <input
                        type="email"
                        value={email}
                        className="input"
                        placeholder="e.g. mymail@provider.com"
                        onChange={(e) => setCredentials((cred) => (
                            { ...cred, email: e.target.value }
                        ))}
                    />
                </div>
                <div className="input-container">
                    <span className="input-cap">Password</span>
                    <input
                        type={toggleShow ? "text" : "password"}
                        value={password}
                        className="input"
                        placeholder="type your password"
                        onChange={(e) => setCredentials((creds) => (
                            { ...creds, password: e.target.value }
                        ))}
                    />
                    <button
                        className="eye-icon"
                        onClick={(e) => {
                            e.preventDefault();
                            setToggleShow((t) => !t);
                        }}
                    >
                        <FontAwesomeIcon
                            icon={toggleShow ? faEye : faEyeSlash}
                        />
                    </button>
                </div>
                <div className="other-ops">
                    <span className="ops-text">
                        <a href="/recoveryemail">Forgot my password</a>
                    </span>
                </div>
                <button
                    className="form-button"
                    onClick={async () => {

                        //setCredentials((creds) => ({...creds, email: "", password: ""}))
                    }}

                >
                    Sign in
                </button>
                <GLoginscreen 
                    loginWithGooogle={() => googleLogin()} 
                />
                <div className="other-ops">
                    <span className="ops-text">Don't have an account? </span>
                    <a href="/register">Create an account</a>
                </div>
            </form>
        </div>
    );
}
